import React, { useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Typography,
  Paper,
} from "@mui/material";
import html2pdf from "html2pdf.js";

const OfferLetterPDF = () => {
  const [formData, setFormData] = useState({
    signatory: "",
    designation: "",
    place: "",
    workOrderNumber: "",
    date: "",
  });

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const downloadPDF = () => {
    const element = document.getElementById("table-to-pdf");
    element.classList.add("pdf-export-mode");

    const opt = {
      margin: [0.2, 0.2, 0.2, 0.2],
      filename: "OfferLetter.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 4,
        useCORS: true,
      },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
      },
    };

    html2pdf()
      .from(element)
      .set(opt)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
        }
      })
      .save()
      .then(() => {
        element.classList.remove("pdf-export-mode");
      });
  };

  return (
    <div>
      {/* Input Fields */}
      <Grid container spacing={2} sx={{ p: 2 }}>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            size="small"
            label="Final Inspection Signatory"
            value={formData.signatory}
            onChange={handleChange("signatory")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            size="small"
            label="Designation"
            value={formData.designation}
            onChange={handleChange("designation")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            size="small"
            label="Place"
            value={formData.place}
            onChange={handleChange("place")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            size="small"
            label="Work Order Number"
            value={formData.workOrderNumber}
            onChange={handleChange("workOrderNumber")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            size="small"
            label="Date"
            type="date"
            value={formData.date}
            onChange={handleChange("date")}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            onClick={downloadPDF}
            sx={{ mt: 1 }}
          >
            Download PDF
          </Button>
        </Grid>
      </Grid>

      {/* PDF Preview */}
      <Paper
        id="table-to-pdf"
        sx={{
          p: 3,
          m: 2,
          fontSize: "11pt",
          lineHeight: 1.5,
          textAlign: "left",
        }}
      >
        <Typography sx={{ mb: 2 }}>To</Typography>

        <Typography sx={{ mb: 2 }}>
          Ref : Your Work Order No. {formData.workOrderNumber} Dated {formData.date}
        </Typography>

        <Typography sx={{ mb: 2 }}>Dear Sir,</Typography>

        <Typography sx={{ mb: 2 }}>
          In reference to above subject the 40 Nos. Overhauling Distribution Transformers is ready at our works
          for <b>FINAL Inspection</b>. Please depute the Inspecting Officer for the same.
        </Typography>

        <Typography sx={{ mb: 2 }}>Thanking you,</Typography>
        <Typography sx={{ mb: 2 }}>Yours faithfully</Typography>

        <Typography sx={{ fontWeight: "bold", mb: 2 }}>
          For RELIANCE ENGINEERS
        </Typography>

        <Typography sx={{ mb: 2 }}>{formData.signatory}</Typography>
        <Typography sx={{ mb: 2 }}>{formData.designation}</Typography>
        <Typography sx={{ mb: 2 }}>{formData.place}</Typography>

        <Typography sx={{ mt: 4, mb: 1 }}>
          <b>Sub:</b> Repair of Distribution Transformers against CRC T No 1715
        </Typography>

        <Typography>(S E (O&M))</Typography>
        <Typography>AVVNL, CHIITTORGARH</Typography>
        <Typography>VKI AREA, JAIPUR</Typography>
        <Typography>
          A14/14A Manu Vihar, Opp. Road No. 9F2, VKI Area, Jaipur(Raj)
        </Typography>

        <Typography sx={{ fontWeight: "bold", mt: 3 }}>
          RELIANCE ENGINEERS
        </Typography>
      </Paper>
    </div>
  );
};

export default OfferLetterPDF;
